import "youtube-background";

$(document).ready(function () {
    $(".section-hero-type-2 [data-vbg]").youtube_background();
});